import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyAirportTransferBenefitsModal from './LandingPageLoyaltyAirportTransferBenefitsModal'

const image: App.Image = {
  id: '0qt5tc9nvf1qd3f0t5fe',
  title: 'Free airport chauffeur service',
}

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
}

function LandingPageLoyaltyAirportTransfersTile(props: Props) {
  const { tier, benefitLabel } = props
  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyAirportTransferBenefitsModal
      image={image}
    />)
  }, [showModal])

  return <LandingPageLoyaltyBenefitTile
    heading="Free airport chauffeur service"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Start and end your journey smoothly with free private airport transfers in select destinations. No stress, just seamless service.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyAirportTransfersTile
